import React, { useCallback, useState, createContext, useContext } from 'react';
import { Dialog, DialogContent, IconButton, Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { QuoteForm } from './QuoteForm';
import { yellowGlowSx } from '../theme';
interface QuoteContextValue {
  openQuote: () => void;
  closeQuote: () => void;
}
const QuoteContext = createContext<QuoteContextValue | undefined>(undefined);
export function useQuote() {
  const ctx = useContext(QuoteContext);
  if (!ctx) {
    throw new Error('useQuote must be used within a QuoteProvider');
  }
  return ctx;
}
export function QuoteProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const openQuote = useCallback(() => setOpen(true), []);
  const closeQuote = useCallback(() => setOpen(false), []);
  return <QuoteContext.Provider value={{
    openQuote,
    closeQuote
  }} data-id="element-115">
      {children}

      <Dialog open={open} onClose={closeQuote} fullScreen={fullScreen} maxWidth="sm" fullWidth aria-labelledby="quote-dialog-title" PaperProps={{
      sx: {
        borderRadius: {
          xs: 0,
          sm: 3
        }
      }
    }} data-id="element-116">
        <Box sx={{
        bgcolor: 'primary.main',
        color: 'white',
        px: {
          xs: 3,
          md: 4
        },
        py: 3,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }} data-id="element-117">
          <Box data-id="element-118">
            <Typography variant="body2" color="secondary.main" fontWeight="bold" textTransform="uppercase" letterSpacing={1} sx={yellowGlowSx} data-id="element-119">
              Free Onsite Estimate
            </Typography>
            <Typography id="quote-dialog-title" variant="h5" fontWeight="bold" data-id="element-120">
              Request Your Free Onsite Estimate
            </Typography>
          </Box>
          <IconButton onClick={closeQuote} aria-label="Close quote form" sx={{
          color: 'white',
          mt: -0.5,
          mr: -1
        }} data-id="element-121">
            <CloseIcon data-id="element-122" />
          </IconButton>
        </Box>

        <DialogContent sx={{
        px: {
          xs: 3,
          md: 4
        },
        py: 4
      }} data-id="element-123">
          <Typography variant="body2" color="text.secondary" sx={{
          mb: 3
        }} data-id="element-124">
            Tell us about your project — no commitment required, and we respect
            your privacy.
          </Typography>
          <QuoteForm hideHeading data-id="element-125" />
        </DialogContent>
      </Dialog>
    </QuoteContext.Provider>;
}